module.exports = __webpack_public_path__ + "static/media/tree-large.6506d04b.svg";